import React from 'react';
import { SearchOptionsDialog as SearchOptionsDialogV2 } from 'components/search-options-dialog/v2/search-options-dialog';

export const SearchOptionsDialog = () => {
    return <SearchOptionsDialogV2 />;
};
